import { useCallback, useEffect, useRef, useState } from "react";
import "../../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap4.css";
import "../../../node_modules/semantic-ui-css/components/icon.min.css";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import React from "react";
import { getDataSetNamePBI, useHttpClient } from "../modules/services/Bundle";
import { IAtivosModel } from "../modules/services/core/_models";
import { RequestMethod } from "../modules/services/core/_enums";
import { useLocation } from "react-router-dom";
import moment from 'moment';

const MenuAtivoDetail: React.FC = () => {
  const location = useLocation();
  const httpClient = useHttpClient();
  const [detalhesAtivo, setDetalhesAtivo] = useState<IAtivosModel[]>([]);
  const [filteredAtivos, setFilteredAtivo] = useState<IAtivosModel[]>([]);
  const [selectedOrganization, setSelectedOrganization] = useState<string>("");
  const [AtivoFilter, setAtivoFilter] = useState<string>("");
  const AtivoTableRef = useRef<HTMLDivElement>(null);
  const chamadosTableRef = useRef<HTMLDivElement>(null);
  const [selectedAtivo, setSelectedAtivo] = useState<string | null>(null);
  const chamadosTable = useRef<Tabulator | null>(null);
  const [chamadosAtivo, setChamadosAtivo] = useState<any[]>([]);
  const dataSetNamePBI = getDataSetNamePBI();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    obterDados();
  }, [location]);
  const obterDados = async () => {
    if (detalhesAtivo.length === 0) await obterDetalhesAtivo();
    const searchParams = new URLSearchParams(location.search);
    const ativoParam = searchParams.get("ativo")?.trim();

    if (ativoParam) {
      setSelectedAtivo(ativoParam);
      handleAtivoSelection(ativoParam);
    }
  }
  const obterDetalhesAtivo = async () => {
    const response = await httpClient.request({
      method: RequestMethod.GET,
      endpoint: '/Gerenciamento/PowerBI/ObterAtivos',
      queryObject: {
        datasetName: dataSetNamePBI,
      },
    });
    if (response.success && response.payload) {
      console.log(response.payload);
      setDetalhesAtivo(response.payload);
      setFilteredAtivo(response.payload);
    }
  };

  const obterChamadosAtivo = async (ativo: string) => {
    try {
      const response = await fetch(`${backendUrl}/api/PrismWorkFlow/ByAtivo/${ativo}`, {
        method: 'GET',
        headers: {
          'Accept': '*/*',
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data);
        setChamadosAtivo(data);
      } else {
        console.error('Erro ao buscar dados:', response.statusText);
      }
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  };

  const handleAtivoSelection = useCallback((ativo: string) => {
    setSelectedAtivo(ativo);
    if (ativo) {
      obterChamadosAtivo(ativo);
    }
  }, []);

  const handleOrganizationFilter = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const organization = event.target.value;
    setSelectedOrganization(organization);
    filterAtivos(organization, AtivoFilter);
  };

  const handleAtivoFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    const ativo = event.target.value;
    setAtivoFilter(ativo);
    filterAtivos(selectedOrganization, ativo);
  };

  const filterAtivos = (organization: string, ativo: string) => {
    let filtered = detalhesAtivo; // Começa com todos os ativos disponíveis
    if (organization) {
      filtered = filtered.filter(g => g['Organizacao'] === organization);
    }
    if (ativo) {
      filtered = filtered.filter(g => g['Ativo'].includes(ativo));
    }
    setFilteredAtivo(filtered); // Atualiza os ativos filtrados
  };

  useEffect(() => {
    if (AtivoTableRef.current) {
      const table = new Tabulator(AtivoTableRef.current, {
        layout: "fitColumns",
        columns: [
          { title: "Campo", field: "field", width: 150 },
          { title: "Valor", field: "value", widthGrow: 1 },
        ],
      });
      if (selectedAtivo) {
        const selectedData = detalhesAtivo.find((detalhes) => detalhes.Ativo === selectedAtivo);
        if (selectedData) {
          const tableData = Object.entries(selectedData).map(([key, value]) => ({
            field: key,
            value: value,
          }));
          table.setData(tableData);
          obterChamadosAtivo(selectedAtivo);
        } else {
          table.clearData();
        }
      } else {
        table.clearData();
      }
    }
  }, [selectedAtivo]);

  const atualizarChamados = () => {
    if (chamadosTableRef.current && selectedAtivo) {
      if (chamadosAtivo.length > 0) {
        if (chamadosTable.current) {
          chamadosTable.current.clearData();
          chamadosTable.current.setData(chamadosAtivo);
        }
      } else {
        chamadosTableRef.current.innerHTML = `<div style="color: gray; text-align: center; padding: 20px;">Não há alertas cadastrados para o ativo ${selectedAtivo}</div>`;
      }
    }
  };

  useEffect(() => {
    if (chamadosTableRef.current) {
      if (selectedAtivo) {
        if (chamadosAtivo.length > 0) {
          chamadosTable.current = new Tabulator(chamadosTableRef.current, {
            height: "400px",
            layout: "fitColumns",
            data: chamadosAtivo,
            initialSort: [
              { column: "DataCriacao", dir: "asc" }
            ],
            columns: [
              {
                title: "", field: "Status", formatter: function (cell, f) {
                  var data = cell.getData();
                  var icon = data.Status ? '<i class="ui small green check icon"></i>' : '<i class="ui small clock icon"></i>';
                  return `<div style="display: flex; align-items: center; justify-content: center;">${icon}</div>`;
                },
                hozAlign: "center", resizable: false, headerSort: false, width: 50,
              },
              {
                title: "", field: "IdAlertLevel", formatter: function (cell, f) {
                  var data = cell.getData();
                  var icon;
                  switch (parseInt(data.IdAlertLevel)) {
                    case 1:
                    case 2:
                      icon = '<i class="ui small yellow exclamation triangle icon"></i>';
                      break;
                    case 3:
                      icon = '<i class="ui small orange exclamation triangle icon"></i>';
                      break;
                    case 4:
                    case 5:
                      icon = '<i class="ui small red exclamation triangle icon"></i>';
                      break;
                    default:
                      icon = '<i class="ui small gray exclamation triangle icon"></i>';
                  }
                  return `<div style="display: flex; align-items: center; justify-content: center;">${icon}</div>`;
                },
                hozAlign: "center", resizable: false, headerSort: false, width: 50,
              },
              {
                title: "Número do Chamado", field: "Chamado", sorter: "string",
                formatter: function (cell, f) {
                  var data = cell.getData();
                  var numeroChamado = data.Chamado;
                  var icon = numeroChamado ? '' : `<i class="ui small red icon plus circle" style="padding: 2px; cursor: pointer;" onclick="window.location.href='/novo-chamado-ativo?var-IdWorkFlow=${data.IdWorkFlow}'">  Incluir</i>`;
                  return `<div style="display: flex; align-items: center;"><span style="margin-right: 5px;">${icon}</span><span>${numeroChamado || ''}</span></div>`;
                },
                hozAlign: "center", resizable: false, headerSort: false, tooltip: 'Número do Chamado', width: 150,
              },
              {
                title: "Interações", field: "Id", sorter: "number",
                formatter: function (cell, f) {
                  var data = cell.getData();
                  var redirectIcon = `<i class="ui small blue icon external alternate" style="padding: 1px; cursor: pointer; color: blue;" onclick="window.location.href='/chamado-ativo?IdWorkFlow=${data.IdWorkFlow}'"></i>`;
                  var balloonIcon = '<i class="ui small icon comment alternate" style="padding: 1px; cursor: pointer;"></i>';
                  return `<div style="display: flex; align-items: center;"><span style="margin-right: 5px;">${redirectIcon}</span><span style="margin-right: 5px;">${balloonIcon}</span><span></span></div>`;
                },
                hozAlign: "center", resizable: false, headerSort: false, tooltip: 'Interações', width: 150,
              },
              { title: "Assunto", field: "Assunto", sorter: "string" },
              { title: "Requisitante", field: "UsuarioOwner", sorter: "string" },
              {
                title: "PDF",
                field: "IdWorkFlow",
                formatter: function (cell) {
                  const idworkflow = cell.getValue();
                  return `<button 
                            class="ui small icon button red"
                            onclick="window.open('${backendUrl}/Report/PrismAlertDownloadPDF?IdWorkFlow=${idworkflow}', '_blank')"
                          >
                            <i class="ui file pdf outline icon"></i>
                          </button>`;
                },
                hozAlign: "center",
                headerSort: false,
                width: 100
              },
              { title: "Responsável", field: "UsuarioResponsible", sorter: "string" },
              {
                title: "Inclusão",
                field: "DataCriacao",
                sorter: (a, b) => {
                  const dateA = moment(a, "DD/MM/YYYY HH:mm:ss", true);
                  const dateB = moment(b, "DD/MM/YYYY HH:mm:ss", true);

                  if (!dateA.isValid() && !dateB.isValid()) return 0;
                  if (!dateA.isValid()) return 1;
                  if (!dateB.isValid()) return -1;

                  return dateB.diff(dateA); // Ordena em ordem decrescente
                },
                formatter: (cell: any) => {
                  const value = cell.getValue();
                  if (!value) return " - ";

                  if (typeof value === 'string' && value.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) {
                    return value;
                  }

                  const date = moment(value);
                  return date.isValid() ? date.format("DD/MM/YYYY HH:mm:ss") : "N/A";
                },
              },
            ],
          });
        } else {
          chamadosTableRef.current.innerHTML = `<div style="color: gray; text-align: center; padding: 20px;">Não há alertas cadastrados para o ativo ${selectedAtivo}</div>`;
        }
      } else {
        chamadosTableRef.current.innerHTML = '';
      }
    }
  }, [selectedAtivo, chamadosAtivo]);

  return (
    <>
      <style>
        {`
          @media (max-width: 1024px) {
            .ativo-detail-container {
              flex-direction: column !important;
            }
            .ativo-sidebar {
              width: 100% !important;
              display: ${selectedAtivo ? 'none' : 'flex'} !important;
            }
            .ativo-details, .ativo-alertas {
              width: 100% !important;
              display: ${selectedAtivo ? 'block' : 'none'} !important;
            }
            .ativo-back-button {
              display: ${selectedAtivo ? 'block' : 'none'} !important;
              margin-bottom: 10px;
            }
          }
          @media (min-width: 1025px) {
            .ativo-back-button {
              display: none !important;
            }
          }
        `}
      </style>
      <div className="d-flex ativo-detail-container" style={{ height: "80vh" }}>
        <div className="ativo-sidebar" style={{ display: "flex", flexDirection: "column", width: "15%", padding: "10px" }}>
          {/* Filtro de Organização */}
          <div style={{ marginBottom: "10px" }}>
            <label htmlFor="organizationFilter" style={{ marginRight: "10px", fontWeight: "bold" }}>Organização:</label>
            <select
              id="organizationFilter"
              value={selectedOrganization}
              onChange={handleOrganizationFilter}
              style={{
                width: "100%",
                padding: "5px",
                borderRadius: "5px",
                border: "1px solid var(--bs-border-color)",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                backgroundColor: "var(--bs-body-bg)",
                color: "var(--bs-body-color)",
              }}
            >
              <option value="">Todas</option>
              {Array.from(new Set(detalhesAtivo.map(ativo => ativo['Organizacao']))).map((organization, index) => (
                <option key={index} value={organization}>{organization}</option>
              ))}
            </select>
          </div>

          {/* Título e Filtro de Ativo */}
          <div style={{ marginBottom: "10px", textAlign: "center" }}>
            <h4 style={{ marginBottom: "10px" }}>Lista de Ativos</h4>
            <input
              type="text"
              placeholder="Digite o codigo do ativo"
              value={AtivoFilter}
              onChange={handleAtivoFilter}
              style={{
                width: "100%",
                padding: "5px",
                borderRadius: "5px",
                border: "1px solid var(--bs-border-color)",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                backgroundColor: "var(--bs-body-bg)",
                color: "var(--bs-body-color)",
              }}
            />
          </div>
          {/* Lista de Gateways */}
          <div
            className="sidebar"
            style={{
              borderRight: "1px solid var(--bs-border-color)",
              borderBottom: "1px solid var(--bs-border-color)",
              padding: "10px",
              overflowY: "auto",
              maxHeight: "100%",
              borderRadius: "5px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <ul style={{ listStyleType: "none", padding: 0 }}>
              {filteredAtivos && filteredAtivos.length > 0 && filteredAtivos.map((ativo: IAtivosModel) => (
                <li
                  key={ativo.Ativo}
                  className={selectedAtivo?.trim() === ativo.Ativo.trim() ? 'selected' : ''}
                  style={{
                    padding: "10px",
                    marginBottom: "8px",
                    border: "1px solid var(--bs-border-color)",
                    borderRadius: "5px",
                    backgroundColor: selectedAtivo?.trim() === ativo.Ativo.trim() ? "var(--bs-secondary-bg)" : "var(--bs-body-bg)",
                    color: "var(--bs-body-color)",
                    fontWeight: selectedAtivo?.trim() === ativo.Ativo.trim() ? "bold" : "normal",
                    cursor: "pointer",
                    transition: "background-color 0.3s ease, color 0.3s ease",
                    textAlign: "center",
                  }}
                  onClick={() => handleAtivoSelection(ativo.Ativo)}
                >
                  {ativo.Ativo}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="ativo-details" style={{ width: "35%", padding: "10px" }}>
          <button 
            className="ativo-back-button btn btn-secondary btn-sm"
            onClick={() => setSelectedAtivo(null)}
          >
            <i className="fas fa-arrow-left"></i> Voltar
          </button>
          <h1 style={{ textAlign: "center", marginBottom: "0px", borderBottom: "0px solid var(--bs-border-color)" }}>Detalhamento do Ativo</h1>
        {selectedAtivo ? (
          <div
            className="detalhamento-ativo"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "5px",
              padding: "20px",
              border: "2px solid var(--bs-border-color)",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
            }}
          >
            {detalhesAtivo
              .filter((ativo) => ativo.Ativo.trim() == selectedAtivo.trim()).map((ativo, index) => (<React.Fragment key={index}>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Nome:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{ativo.Ativo}</div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Descrição:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{ativo.Descricao}</div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Última Visualização:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{ativo.UltimaVisualizacao}</div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Local:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{ativo.Local}</div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Descrição do local:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{ativo.LocalDescricao}</div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Tipo de local:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{ativo.PlaceType}</div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Organização:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{ativo.Organizacao}</div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Beacon:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{ativo.IdBeacon}</div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Status do Ativo:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{ativo.AtivoSituacao}</div>
              </React.Fragment>
              ))}
          </div>
        ) : (
          <p style={{ textAlign: "center" }}>Selecione um Ativo para ver os detalhes</p>
        )}
      </div>

      {/* Menu lateral de Chamados */}
      <div className="ativo-alertas" style={{ width: "56%", borderLeft: "1px solid var(--bs-border-color)", padding: "5px" }}>
        <h4>Alertas</h4>
        <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'flex-start', gap: '10px' }}>
          <button onClick={() => window.location.href = `/Criar-alerta-ativo?ativo=${selectedAtivo}`} style={{ display: 'flex', alignItems: 'center', padding: '5px 10px', borderRadius: '5px', border: "1px solid var(--bs-border-color)", backgroundColor: "var(--bs-body-bg)", color: "var(--bs-body-color)", cursor: 'pointer' }}>
            <i className="fas fa-plus" style={{ marginRight: '5px' }}></i> Novo
          </button>
          <button onClick={atualizarChamados} style={{ display: 'flex', alignItems: 'center', padding: '5px 10px', borderRadius: '5px', border: "1px solid var(--bs-border-color)", backgroundColor: "var(--bs-body-bg)", color: "var(--bs-body-color)", cursor: 'pointer' }}>
            <i className="fas fa-sync-alt" style={{ marginRight: '5px' }}></i> Atualizar
          </button>
        </div>
        <div ref={chamadosTableRef}></div>
      </div>
    </div>
    </>
  );
};

export default MenuAtivoDetail;